import api from "../services/api";

export const listContacts = (params = {}) => api.get("/api/contacts", { params });
export const getContact = (id, phone_id) => api.get(`/api/contacts/${id}`, { params: { phone_id } });
export const getContactDetails = (id, phone_id, params = {}) =>
  api.get(`/api/contacts/${id}/details`, { params: { phone_id, ...params } });
export const createContact = (payload) => api.post("/api/contacts", payload);
export const updateContact = (id, payload) => api.put(`/api/contacts/${id}`, payload);
export const deleteContact = (id, phone_id) => api.delete(`/api/contacts/${id}`, { params: { phone_id } });
export const bulkContactAction = (payload) => api.post("/api/contacts/bulk", payload);
